import clsx from "clsx";

export function TiktokIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
          className={clsx('text-[#5B5B5B]', className)}
          aria-hidden="true"
    >
      <path
        d="M18.7209 5.67285C17.5231 5.67285 16.4179 5.27604 15.5304 4.60663C14.5126 3.83925 13.7812 2.71359 13.523 1.41617C13.459 1.0956 13.4246 0.764791 13.4213 0.425781H9.99967V9.77541L9.99557 14.8966C9.99557 16.2658 9.10397 17.4267 7.86804 17.835C7.50936 17.9535 7.12197 18.0096 6.71861 17.9875C6.20374 17.9592 5.72125 17.8038 5.3019 17.553C4.40948 17.0192 3.80443 16.051 3.78803 14.9434C3.76221 13.2122 5.1617 11.8009 6.89159 11.8009C7.23306 11.8009 7.56101 11.8566 7.86804 11.9579V9.40238V8.48373C7.5442 8.43577 7.21462 8.41076 6.88135 8.41076C4.98789 8.41076 3.217 9.19782 1.95115 10.6158C0.994376 11.6873 0.420477 13.0544 0.331933 14.4879C0.215923 16.3711 0.905011 18.1613 2.24138 19.4821C2.43773 19.676 2.64392 19.8559 2.85955 20.022C4.00529 20.9037 5.40602 21.3817 6.88135 21.3817C7.21462 21.3817 7.5442 21.3571 7.86804 21.3091C9.24622 21.105 10.5178 20.4741 11.5213 19.4821C12.7544 18.2634 13.4357 16.6454 13.4431 14.9233L13.4254 7.27567C14.0137 7.72946 14.6569 8.10496 15.3472 8.39641C16.4208 8.84938 17.5591 9.07894 18.7307 9.07853V6.59396V5.67203C18.7315 5.67285 18.7217 5.67285 18.7209 5.67285Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  )
}
